import { ActivityResultType, ActivityStatus, ActivityType } from "../../types/activityTypes";

export const getActivityTypeLabel = (type: ActivityType) => {
  const labels: Record<ActivityType, string> = {
    [ActivityType.CALL]: "Anruf",
    [ActivityType.MAIL]: "E-Mail",
    [ActivityType.MEETING]: "Meeting",
    [ActivityType.OTHER]: "Sonstiges",
  };

  return labels[type];
};

export const getActivityStatusLabel = (status: ActivityStatus) => {
  const labels: Record<ActivityStatus, string> = {
    [ActivityStatus.OPEN]: "Offen",
    [ActivityStatus.WAITING_FOR_CUSTOMER]: "Wartend",
    [ActivityStatus.DONE]: "Erledigt",
  };

  return labels[status];
};

export const getActivityResultTypeLabel = (resultType: ActivityResultType) => {
  const labels: Record<ActivityResultType, string> = {
    [ActivityResultType.POTENTIAL_FUTURE_PROJECT]: "Potenzielles Folgeprojekt",
    [ActivityResultType.KEEP_CONTACT]: "Kontakt halten",
    [ActivityResultType.DO_NOT_KEEP_CONTACT]: "Kein weiterer Kontakt",
  };

  return labels[resultType];
};
